<template>
    <div class="col-12">
        <h4 class="bg-success p-2">
            Bloco I - Famílias em acompanhamento pelo PAIF
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>A.</th>
                <td>Volume de famílias em acompanhamento pelo PAIF</td>
                <td>Total</td>
            </tr>

            <tr>
                <td>A.1.</td>
                <td>Total de famílias em acompanhamento pelo PAIF</td>
                <td>{{ dados.total_familia_acompanhamento }}</td>
            </tr>
            <tr>
                <td>A.2.</td>
                <td>
                    Novas famílias inseridas no acompanhamento do PAIF durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_acompanhamento_mes }}</td>
            </tr>
            <tr class="bg-success">
                <th>B.</th>
                <td>
                    Perfil das novas famílias inseridas em acompanhamento no
                    PAIF no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>Total</td>
            </tr>
            <tr>
                <td>B.1.</td>
                <td>Famílias em situação de pobreza</td>
                <td>{{ dados.total_familia_pobreza }}</td>
            </tr>
            <tr>
                <td>B.2.</td>
                <td>Famílias beneficiárias do {{ $t("Bolsa Família") }}</td>
                <td>{{ dados.total_familia_bolsa_familia }}</td>
            </tr>
            <tr>
                <td>B.3.</td>
                <td>
                    Famílias beneficiárias do {{ $t("Bolsa Família") }} em não cumprimento das condicionalidades
                </td>
                <td>{{ dados.total_familia_bolsa_familia_descumprimentos }}</td>
            </tr>
            <tr>
                <td>B.4.</td>
                <td>Famílias com membros beneficiários do BPC</td>
                <td>{{ dados.total_familia_bpc }}</td>
            </tr>
            <tr>
                <td>B.5.</td>
                <td>
                    Famílias com crianças ou adolescentes em situação de
                    trabalho infantil
                </td>
                <td>{{ dados.total_familia_trabalho_infantil }}</td>
            </tr>
            <tr>
                <td>B.6.</td>
                <td>
                    Famílias com crianças ou adolescentes em Serviço de
                    Acolhimento
                </td>
                <td>{{ dados.total_familia_acolhimento }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Os itens <b>B1</b> a
            <b>B6</b> identificam apenas alguns perfis de famílias. É normal que
            algumas famílias contadas no item não se enquadrem em nenhuma das
            condições acima, enquanto outras podem se enquadrar simultaneamente
            em mais de uma condição. Portanto, a soma de <b>B1</b> a
            <b>B6</b> não terá, necessariamente, o mesmo valor relatado em
            <b>A2</b>.
        </p>
        <h4 class="bg-success p-2">
            Bloco 2 - Atendimentos particularizados realizados no CRAS
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>C.</th>
                <td>
                    Volume de atendimentos particularizados realizados no CRAS
                    no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>Quantidade</td>
            </tr>
            <tr>
                <td>C.1.</td>
                <td>
                    Total de atendimentos particularizados realizados no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_atendimento_particular }}</td>
            </tr>
            <tr>
                <td>C.2.</td>
                <td>Famílias encaminhadas para inclusão no Cadastro Único</td>
                <td>
                    {{ dados.total_encaminhamento_cadastramento }}
                </td>
            </tr>
            <tr>
                <td>C.3.</td>
                <td>
                    Famílias encaminhadas para atualização cadastral no Cadastro
                    Único
                </td>
                <td>
                    {{ dados.total_encaminhamento_atualizacao }}
                </td>
            </tr>
            <tr>
                <td>C.4.</td>
                <td>Indivíduos encaminhados para acesso ao BPC</td>
                <td>{{ dados.total_encaminhado_bpc }}</td>
            </tr>
            <tr>
                <td>C.5.</td>
                <td>Famílias encaminhadas para o CREAS</td>
                <td>{{ dados.total_encaminhado_creas }}</td>
            </tr>
            <tr>
                <td>C.6.</td>
                <td>Visitas domiciliares realizadas</td>
                <td>{{ dados.total_visita }}</td>
            </tr>
            <tr>
                <td>C.7.</td>
                <td>
                    Total de auxílios-natalidade entregues durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_familia_auxilios_natalidade }}</td>
            </tr>
            <tr>
                <td>C.8.</td>
                <td>
                    Total de auxílios-funeral entregues durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_familia_auxilios_funeral }}</td>
            </tr>
            <tr>
                <td>C.9</td>
                <td>
                    Outros benefícios eventuais entregues durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>{{ dados.total_familia_beneficios_eventuais }}</td>
            </tr>
        </table>

        <p>
            <b class="text-danger">Atenção!</b> Nos campos <b>C1</b> a
            <b>C6</b> devem ser contabilizadas todas as famílias/indivíduos,
            independente de estarem, ou não, em acompanhamento sistemático do
            PAIF. Nos campos <b>C7</b>, <b>CB</b> e <b>C9</b>, considere os
            auxílios e os benefícios eventuais concedidos <b>e/ou</b> entregues
            no CRAS. Caso o CRAS não conceda nem entregue auxílios ou
            benefícios-eventuais marque 0 (zero) nos respectivos campos.
        </p>
        <h4 class="bg-success p-2">
            Bloco 3 - Atendimentos coletivos realizados no CRAS
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>D.</th>
                <td>
                    Volume de atendimentos coletivos realizados no CRAS durante
                    o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td>Quantidade</td>
            </tr>
            <tr>
                <td>D.1.</td>
                <td>
                    Famílias participando regularmente de grupos no âmbito do
                    PAIF
                </td>
                <td>{{ dados.familia_grupos_paif }}</td>
            </tr>
            <tr>
                <td>D.2.</td>
                <td>
                    Crianças de 0 a 6 anos em Serviços de Convivência e
                    Fortalecimento de Vínculos
                </td>
                <td>{{ dados.total_0_6_fortalecimento_vinculo }}</td>
            </tr>
            <tr>
                <td>D.3.</td>
                <td>
                    Crianças/adolescentes de 7 a 14 anos em Serviços de
                    Convivência e Fortalecimento de Vínculos
                </td>
                <td>{{ dados.total_7_14_fortalecimento_vinculo }}</td>
            </tr>
            <tr>
                <td>D.4.</td>
                <td>
                    Adolescentes de 15 a 17 anos em Serviços de Convivência e
                    Fortalecimento de Vínculos
                </td>
                <td>{{ dados.total_15_17_fortalecimento_vinculo }}</td>
            </tr>
            <tr>
                <td>D.8.</td>
                <td>
                    Adultos entre 18 e 59 anos em Serviços de Convivência e
                    Fortalecimento de Vínculos
                </td>
                <td>{{ dados.total_18_59_fortalecimento_vinculo }}</td>
            </tr>
            <tr>
                <td>D.5.</td>
                <td>
                    Pessoas idosas em Serviços de Convivência e Fortalecimento de
                    Vínculos para idosos
                </td>
                <td>{{ dados.total_60_mais_fortalecimento_vinculo }}</td>
            </tr>
            <tr>
                <td>D.6.</td>
                <td>
                    Pessoas que participaram de palestras, oficinas e outras
                    atividades coletivas de caráter não continuado
                </td>
                <td>{{ dados.total_participa_oficina }}</td>
            </tr>
            <tr>
                <td>D.7.</td>
                <td>
                    Pessoas com deficiência, participando dos Serviços de
                    Convivência ou dos grupos do PAIF
                </td>
                <td>{{ dados.total_pessoas_deficiencia }}</td>
            </tr>
        </table>

        <p>
            Apesar dos serviços de convivência não estarem mais vinculados a
            faixas etárias, para facilidade de os usuários devem ser
            contabilizados de acordo com a sua idade, independente de estarem,
            ou não, no mesmo grupo.
        </p>
        <div v-if="periodo == 'Anual'">
            <h4>
                Formulário 2 - Registro das Famílias Incluídas em Acompanhamento
                pelo PAIF
            </h4>
            <table class="table table-bordered">
                <tr class="bg-success">
                    <th>Código Familiar</th>
                    <th>Responsável Familiar</th>
                    <th>Forma de Acesso</th>
                    <th>Encaminhamentos</th>
                </tr>
                <tr
                    v-for="item in dados.familias_acompanhamento"
                    :key="item.id"
                >
                    <td>{{ item.codigo_familiar }}</td>
                    <td>
                        {{ item.responsavel_familiar }}
                    </td>
                    <td>{{ item.forma_ingresso }}</td>
                    <td>{{ item.encaminhamentos }}</td>
                </tr>
            </table>
        </div>
        <h4 v-if="footer != false">
            Nome e cargo da pessoa responsável no CRAS pelas informações:
        </h4>
        <div v-if="footer != false" class="row px-3 mt-4">
            <div class="col-8 pl-0 border-bottom">Assinatura:</div>
            <div class="col-4 border-bottom">CPF:</div>
        </div>

        <div class="footer_impressao">
            <div v-if="tecnico">
                <span><strong>Técnico responsável:</strong> {{ tecnico.nome }}</span>
                <span v-if="tecnico.profissao"><strong>Cargo:</strong> {{ tecnico.profissao }}</span>
                <span><strong>Data/Hora da emissão:</strong> {{ dataHoraAtual }}</span>
            </div>
        </div>

    </div>
</template>

<style>

    .footer_impressao {
        display: none;
    }

    /* Se quiser que apareça apenas na impressão */
    @media print {
        .footer_impressao {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            border-top: 1px solid #ccc;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    /* Adiciona o separador " - " automaticamente entre os spans */
    .footer_impressao span:not(:last-child)::after {
        content: " - ";
        margin: 0 5px;
    }

</style>

<script>
export default {
    name: "RMA_CRAS",
    props: ["mes", "ano", "periodo", "unidade", "dados", "header", "footer"],
    data() {
        return {
            unidadeSelected: "",
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            itens: [],
            tecnico: null,
            dataHoraAtual: null,
        };
    },

    mounted() {
        this.getTecnico();
        this.definirDataHoraAtual();
    },

    watch: {
        unidade() {
            this.getUnidade();
        },
    },
    methods: {
        getUnidade() {
            axios
                .get(`api/dashboard/unidades/${this.unidade}`)
                .then((response) => {
                    this.unidadeSelected = response.data.data;
                });
        },
        getTecnico() {
            const userId = this.$store.state.user.id;

            axios.get(`/api/dashboard/tecnico/get/user_id/${userId}`).then((response) => {
                this.tecnico = response.data.data;
            })
            .catch((error) => {
                console.error("Erro ao buscar técnico:", error);
            });
        },

        definirDataHoraAtual() {
            const agora = new Date();
            const dataFormatada = agora.toLocaleDateString("pt-BR");
            const horaFormatada = agora.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
            this.dataHoraAtual = `${dataFormatada} ${horaFormatada}`;
        },
    },
};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
